import styled from "styled-components";

const MembersTabSwitch = ({
  manageSelected,
  rankingSelected,
  onManageClick,
  onRankingClick,
}) => {
  return (
    <div className="hrz-wrapper">
      <DataOptionBtn onClick={onManageClick} $isSelected={manageSelected}>
        구성원 관리
      </DataOptionBtn>
      <DataOptionBtn onClick={onRankingClick} $isSelected={rankingSelected}>
        실시간 랭킹
      </DataOptionBtn>
    </div>
  );
};

const DataOptionBtn = styled.p`
  width: 87px;
  height: 56px;
  font-family: "notoSans-medium";
  font-size: 18px;
  color: ${(props) => (props.$isSelected ? "#1167ed" : "#8e96a0")};
  border-bottom: ${(props) =>
    props.$isSelected ? "2px solid #1167ed" : "none"};
  display: flex;
  align-items: center;
  margin: 0;
  margin-right: 14px;
  cursor: pointer;
`;

export default MembersTabSwitch;
